import "./GanttZoomControls.css";

import { JSX } from "react/jsx-runtime";

import { ROADMAP_ZOOMS, TASKS_ZOOMS } from "../../constants";
import { GanttZoomControlsProps } from "../../models";

export const GanttZoomControls = ({ variant, zoom, onChange }: GanttZoomControlsProps): JSX.Element => {
  const options = variant === "project-roadmap" ? ROADMAP_ZOOMS : TASKS_ZOOMS;

  return (
    <div className="GanttSegmented" role="group" aria-label="Zoom level">
      {options.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          className={`GanttSegmentedOption body3${zoom === key ? " GanttSegmentedOptionActive" : ""}`}
          onClick={() => onChange(key)}
          aria-pressed={zoom === key}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
